import TopNav from '@/components/Home/TopNav.vue';
import SwpierTop from '@/components/Home/SwpierTop.vue';
import IconList from '@/components/Home/IconList.vue';
import MusicList from '@/components/Home/MusicList.vue'; // import LikeMusic from '@/components/Home/LikeMusic.vue'

export default {
  name: 'Home',
  components: {
    TopNav,
    SwpierTop,
    IconList,
    MusicList // LikeMusic

  }
};